// DS: C39
/** A navigation bar with actions related to the deviation on top of it */ import React from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import ActionBarContent from './_partials/ActionBarContent';
import CustomNotificationProvider from '../Notifications/CustomNotificationContext';
import { getDeviationNotificationQueue } from '../DeviationPage/redux/helpers';
import { ActionBarDialogContext } from './ActionBarContext';
import { ElementVisibilityContextProvider } from './ElementVisibilityContext';
const ActionBar = (props)=>{
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            itemid: props.deviation.deviationId,
            typeid: getDeviationResourceType(props.deviation)
        }
    }, /*#__PURE__*/ React.createElement(ActionBarDialogContext.Provider, {
        value: !!props.isAnyDialogOpen
    }, /*#__PURE__*/ React.createElement(ElementVisibilityContextProvider, {
        deviation: props.deviation
    }, /*#__PURE__*/ React.createElement(CustomNotificationProvider, {
        queueName: getDeviationNotificationQueue(props.deviation)
    }, /*#__PURE__*/ React.createElement(ActionBarContent, props)))));
};
ActionBar.displayName = 'ActionBar';
export default ActionBar;
